document.addEventListener("DOMContentLoaded", function () {

    document.addEventListener("click", function (event) {
        const button = event.target.closest(".ludic-slide.ecl-slip-on.diwali a.slider-btn[data-copy-code]");
        if (!button || button.dataset.copyPending === "true") return;

        event.preventDefault();
        button.dataset.copyPending = "true";
        const tooltip = button.querySelector(".diwali-copy-tooltip");

        function finishCopy(copied) {
            if (tooltip) {
                tooltip.textContent = copied ? "Copied" : "Copy failed";
                tooltip.classList.add("is-visible");
                window.setTimeout(function () {
                    tooltip.classList.remove("is-visible");
                }, 700);
            }
            window.setTimeout(function () {
                window.location.assign(button.href);
            }, 900);
        }

        function fallbackCopy() {
            const input = document.createElement("textarea");
            input.value = button.dataset.copyCode;
            input.setAttribute("readonly", "");
            input.style.position = "fixed";
            input.style.opacity = "0";
            document.body.appendChild(input);
            input.select();
            let copied = false;
            try {
                copied = document.execCommand("copy");
            } finally {
                input.remove();
            }
            return copied;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(button.dataset.copyCode)
                .then(function () { finishCopy(true); })
                .catch(function () { finishCopy(fallbackCopy()); });
        } else {
            finishCopy(fallbackCopy());
        }
    });

    const slider = document.querySelector(".ludic-slider");
    if (!slider) return;

    const wrapper = slider.querySelector(".ludic-slider__wrapper");
    const originalSlides = slider.querySelectorAll(".ludic-slide");
    const dots = slider.querySelectorAll(".dot");

    const realSlideCount = originalSlides.length;
    document.body.classList.toggle(
        "ludic-diwali-header",
        Boolean(originalSlides[0] && originalSlides[0].classList.contains("diwali"))
    );

    // If there is only one slide, we do not need to do anything
    if (realSlideCount <= 1) return;

    // Clone the first and last slides for infinite looping
    const firstClone = originalSlides[0].cloneNode(true);
    const lastClone = originalSlides[realSlideCount - 1].cloneNode(true);
    
    firstClone.classList.add("ludic-slide-clone");
    lastClone.classList.add("ludic-slide-clone");

    wrapper.appendChild(firstClone);
    wrapper.insertBefore(lastClone, originalSlides[0]);

    const slides = wrapper.querySelectorAll(".ludic-slide");

    // Because of the prepend clone, the first actual slide is now at index 1
    let index = 1;
    let isTransitioning = false;

    const autoplay = slider.dataset.autoplay === "true";
    const speed = parseInt(slider.dataset.speed) || 5000;
    let interval;
    
    // Set initial position without animation
    wrapper.style.transition = "none";
    wrapper.style.transform = `translateX(-${index * 100}%)`;

    /* ---------- SLIDE CHANGE ---------- */

    function goToSlide(i) {
        if (isTransitioning) return;
        isTransitioning = true;
        
        index = i;
        wrapper.style.transition = "transform 0.8s cubic-bezier(0.25, 1, 0.5, 1)";
        wrapper.style.transform = `translateX(-${index * 100}%)`;

        // Update dots mapping (index 1 maps to dot 0)
        let dotIndex = index - 1;
        if (index === 0) dotIndex = realSlideCount - 1; // last clone -> last dot
        if (index === realSlideCount + 1) dotIndex = 0; // first clone -> first dot

        dots.forEach(dot => dot.classList.remove("active"));
        if (dots[dotIndex]) dots[dotIndex].classList.add("active");

        // Handle video active state
        const activeSlide = slides[index];
        document.body.classList.toggle(
            "ludic-diwali-header",
            Boolean(activeSlide && activeSlide.classList.contains("diwali"))
        );
        if (activeSlide) {
            const hasVideo = activeSlide.querySelector("video");
            if (hasVideo) {
                document.body.classList.add("ludic-video-active");
            } else {
                document.body.classList.remove("ludic-video-active");
            }
        }
    }

    /* ---------- TRANSITION END FOR INFINITE LOOP ---------- */

    wrapper.addEventListener("transitionend", () => {
        isTransitioning = false;

        // If we reached the cloned first slide (at the end of wrapper)
        if (index === realSlideCount + 1) {
            wrapper.style.transition = "none";
            index = 1;
            wrapper.style.transform = `translateX(-${index * 100}%)`;
        }
        
        // If we reached the cloned last slide (at the start of wrapper)
        if (index === 0) {
            wrapper.style.transition = "none";
            index = realSlideCount;
            wrapper.style.transform = `translateX(-${index * 100}%)`;
        }
    });

    /* ---------- AUTOPLAY ---------- */

    function startAuto() {
        if (!autoplay) return;

        interval = setInterval(() => {
            goToSlide(index + 1);
        }, speed);
    }

    function resetAuto() {
        clearInterval(interval);
        startAuto();
    }

    /* ---------- DOT CLICK ---------- */

    dots.forEach(dot => {
        dot.addEventListener("click", function () {
            // dots dataset is 0-indexed, so we add 1 for actual slide index
            const targetIndex = parseInt(this.dataset.dot) + 1;
            if (targetIndex !== index) {
                goToSlide(targetIndex);
                resetAuto();
            }
        });
    });

    /* ---------- DRAG & SWIPE (MOUSE + TOUCH) ---------- */

    let isDragging = false;
    let startPos = 0;
    let prevTranslatePx = 0;
    let startY = 0;
    let isVerticalScrolling = false;
    let draggedDistance = 0;
    
    function getPositionX(event) {
        return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }
    
    function getPositionY(event) {
        return event.type.includes('mouse') ? event.pageY : event.touches[0].clientY;
    }

    function touchStart(event) {
        if (isTransitioning) return;
        
        startPos = getPositionX(event);
        startY = getPositionY(event);
        isDragging = true;
        isVerticalScrolling = false;
        draggedDistance = 0;
        
        clearInterval(interval); 
        
        const slideWidth = slider.clientWidth;
        prevTranslatePx = -index * slideWidth; 
        
        wrapper.style.transition = 'none'; 
        
        if (event.type === 'mousedown') {
            event.preventDefault();
            slider.style.cursor = 'grabbing';
        }
    }

    function touchMove(event) {
        if (!isDragging) return;
        
        const currentPosition = getPositionX(event);
        const currentPositionY = getPositionY(event);
        const deltaX = currentPosition - startPos;
        const deltaY = currentPositionY - startY;
        
        draggedDistance = Math.max(draggedDistance, Math.abs(deltaX), Math.abs(deltaY));
        
        // Detect if the user is mostly scrolling vertically
        if (event.type === 'touchmove') {
            if (!isVerticalScrolling && Math.abs(deltaY) > Math.abs(deltaX)) {
                isVerticalScrolling = true;
            }
        }
        
        if (isVerticalScrolling) {
            isDragging = false; // Cancel drag so the page can scroll naturally
            wrapper.style.transition = "transform 0.8s cubic-bezier(0.25, 1, 0.5, 1)";
            wrapper.style.transform = `translateX(-${index * 100}%)`;
            return;
        }

        const currentTranslatePx = prevTranslatePx + deltaX;
        wrapper.style.transform = `translateX(${currentTranslatePx}px)`;
    }

    function touchEnd(event) {
        if (!isDragging) return;
        isDragging = false;
        
        if (event.type === 'mouseup' || event.type === 'mouseleave') {
            slider.style.cursor = 'grab';
        }

        const transformStr = wrapper.style.transform;
        const match = transformStr.match(/translateX\(([-\d.]+)px\)/);
        
        if (match) {
            const currentPx = parseFloat(match[1]);
            const deltaX = currentPx - prevTranslatePx;
            const threshold = slider.clientWidth * 0.15; // 15% threshold for swipe
            
            wrapper.style.transition = "transform 0.8s cubic-bezier(0.25, 1, 0.5, 1)";
            
            if (deltaX < -threshold) {
                isTransitioning = false; 
                goToSlide(index + 1);
            } else if (deltaX > threshold) {
                isTransitioning = false; 
                goToSlide(index - 1);
            } else {
                // Snap back
                wrapper.style.transform = `translateX(-${index * 100}%)`;
                
                isTransitioning = true;
                setTimeout(() => {
                    isTransitioning = false;
                }, 800);
            }
        }
        
        resetAuto();
    }

    slider.addEventListener('touchstart', touchStart, {passive: true});
    slider.addEventListener('touchmove', touchMove, {passive: true});
    slider.addEventListener('touchend', touchEnd);
    slider.addEventListener('touchcancel', touchEnd);
    
    slider.addEventListener('mousedown', touchStart);
    slider.addEventListener('mousemove', touchMove);
    slider.addEventListener('mouseup', touchEnd);
    slider.addEventListener('mouseleave', touchEnd);
    
    // Prevent link clicks if user dragged
    slider.addEventListener('click', function(e) {
        if (draggedDistance > 5) {
            e.preventDefault();
            e.stopPropagation();
        }
    }, true);
    
    slider.style.cursor = 'grab';

    /* ---------- TRACKPAD SWIPE (DESKTOP) ---------- */

    let trackpadLocked = false;
    let accumulatedDelta = 0;

    slider.addEventListener("wheel", function(e){
        // detect horizontal swipe only
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;

        e.preventDefault();

        if (trackpadLocked || isTransitioning) return;

        accumulatedDelta += e.deltaX;

        const threshold = 120; // swipe sensitivity

        if (Math.abs(accumulatedDelta) > threshold) {
            trackpadLocked = true;

            if (accumulatedDelta > 0) {
                goToSlide(index + 1);
            } else {
                goToSlide(index - 1);
            }

            resetAuto();
            accumulatedDelta = 0;

            setTimeout(() => {
                trackpadLocked = false;
            }, 700); 
        }

    }, { passive:false });

    /* ---------- INIT ---------- */

    dots.forEach(dot => dot.classList.remove("active"));
    if (dots[0]) dots[0].classList.add("active");

    const activeSlide = slides[index];
    if (activeSlide) {
        document.body.classList.toggle(
            "ludic-diwali-header",
            activeSlide.classList.contains("diwali")
        );
        const hasVideo = activeSlide.querySelector("video");
        if (hasVideo) {
            document.body.classList.add("ludic-video-active");
        }
    }

    startAuto();

    const revealWrapper = slider.closest('.ludic-slider-reveal');
    if (revealWrapper) {
        // slight delay to ensure first paint of initialized slider is ready
        requestAnimationFrame(() => {
            revealWrapper.classList.add('js-loaded');
        });
    }

});
